/**
 * Blocks AST -> canonical expression text
 * For Media Devoted | Created By Ciro Autiero
 *
 * Thin wrapper over the shared serializer so the FE can keep its block UI
 * imports decoupled from the rest of the formula module.
 */

import { serializeBlock } from '@trafficpulse/shared';
import type { FormulaBlockNode } from '@trafficpulse/shared';

export function serializeBlocks(node: FormulaBlockNode | null | undefined): string {
  return serializeBlock(node ?? null);
}
